import React from "react";

export const AmountIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="currentColor"
  >
    <path d="M7.032,1.953V1.7A0.759,0.759,0,0,0,6.275.944H3.754A0.759,0.759,0,0,0,3,1.7V1.953H0V3.97H3V4.223a0.759,0.759,0,0,0,.756.756H6.275a0.759,0.759,0,0,0,.756-0.756V3.97H17.953V1.953H7.032ZM4.006,3.97V1.953H6.023V3.97H4.006Zm6.931,2.983V6.7a0.759,0.759,0,0,1,.757-0.756h2.522a0.759,0.759,0,0,1,.756.756V6.953h2.995V8.97H14.972V9.222a0.759,0.759,0,0,1-.756.757H11.693a0.759,0.759,0,0,1-.757-0.757V8.97H0.016V6.953H10.937ZM13.963,8.97V6.953H11.946V8.97h2.017ZM7.032,11.953V11.7a0.759,0.759,0,0,0-.756-0.757H3.754A0.759,0.759,0,0,0,3,11.7v0.252H0V13.97H3v0.252a0.759,0.759,0,0,0,.756.756H6.275a0.759,0.759,0,0,0,.756-0.756V13.97H17.953V11.953H7.032ZM4.006,13.97V11.953H6.023V13.97H4.006Z" />
  </svg>
);

export const DealsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M2.928,3.634V0.706a0.732,0.732,0,0,1,1.464,0V3.634A0.732,0.732,0,0,1,2.928,3.634Zm11.4,0.732a0.731,0.731,0,0,0,.732-0.732V0.706a0.732,0.732,0,1,0-1.464,0V3.634A0.731,0.731,0,0,0,14.33,4.366ZM23.421,17.54a5.855,5.855,0,1,1-5.855-5.855A5.856,5.856,0,0,1,23.421,17.54Zm-1.464,0a4.391,4.391,0,1,0-4.392,4.392A4.4,4.4,0,0,0,21.957,17.54ZM1.441,16.355V6.446H16.526v3.775H17.99V4.512A1.6,1.6,0,0,0,16.4,2.9h-0.61V3.634a1.464,1.464,0,0,1-2.928,0V2.9H5.123V3.634a1.464,1.464,0,1,1-2.928,0V2.9H1.586A1.6,1.6,0,0,0,0,4.512V16.355a1.6,1.6,0,0,0,1.586,1.61h8.661V16.5H1.564A0.139,0.139,0,0,1,1.441,16.355Zm18.466-.49a0.551,0.551,0,0,0-.78,0l-1.95,1.95-1.17-1.17a0.551,0.551,0,1,0-.78.78l1.56,1.56a0.551,0.551,0,0,0,.78,0l2.339-2.339A0.551,0.551,0,0,0,19.907,15.864ZM3.384,8.573V7.854H14.413V8.573H3.384Zm0,2.156V10.01H14.413v0.719H3.384Zm0,2.178V12.188h8.243v0.719H3.384Zm0,2.156V14.344H10.19v0.719H3.384Z" />
  </svg>
);

export const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="currentColor"
  >
    <path d="M5,6.609L9.9,1.715l-1.4-1.4L5,3.818l-3.5-3.5-1.4,1.4L4.986,6.609,5,6.6Z" />
  </svg>
);

export const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fillRule="evenodd"
    fill="currentColor"
  >
    <path d="M14.972,8.970 L14.972,9.222 C14.972,9.639 14.631,9.979 14.215,9.979 L11.693,9.979 C11.277,9.979 10.937,9.639 10.937,9.222 L10.937,8.970 L0.015,8.970 L0.015,6.953 L10.937,6.953 L10.937,6.701 C10.937,6.285 11.277,5.944 11.693,5.944 L14.215,5.944 C14.631,5.944 14.972,6.285 14.972,6.701 L14.972,6.953 L17.966,6.953 L17.966,8.970 L14.972,8.970 ZM13.963,6.953 L11.946,6.953 L11.946,8.970 L13.963,8.970 L13.963,6.953 ZM7.032,4.222 C7.032,4.639 6.691,4.979 6.275,4.979 L3.754,4.979 C3.338,4.979 2.997,4.639 2.997,4.222 L2.997,3.970 L0.002,3.970 L0.002,1.953 L2.997,1.953 L2.997,1.701 C2.997,1.285 3.338,0.944 3.754,0.944 L6.275,0.944 C6.691,0.944 7.032,1.285 7.032,1.701 L7.032,1.953 L17.953,1.953 L17.953,3.970 L7.032,3.970 L7.032,4.222 ZM6.023,1.953 L4.006,1.953 L4.006,3.970 L6.023,3.970 L6.023,1.953 ZM2.997,11.701 C2.997,11.285 3.338,10.944 3.754,10.944 L6.275,10.944 C6.691,10.944 7.032,11.285 7.032,11.701 L7.032,11.953 L17.953,11.953 L17.953,13.970 L7.032,13.970 L7.032,14.222 C7.032,14.639 6.691,14.979 6.275,14.979 L3.754,14.979 C3.338,14.979 2.997,14.639 2.997,14.222 L2.997,13.970 L0.002,13.970 L0.002,11.953 L2.997,11.953 L2.997,11.701 ZM4.006,13.970 L6.023,13.970 L6.023,11.953 L4.006,11.953 L4.006,13.970 Z" />
  </svg>
);

export const TradingHistoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.417 23.425">
    <path
      fill="currentColor"
      d="M94.563,189.4a5.855,5.855,0,1,1,5.856-5.855,5.855,5.855,0,0,1-5.856,5.855Zm0-10.249a4.393,4.393,0,1,0,4.392,4.393,4.393,4.393,0,0,0-4.392-4.393Zm1.944,5.9h-2a.546.546,0,0,1-.551-.552v-2.975a.551.551,0,0,1,1.1,0v2.424h1.446a.552.552,0,0,1,0,1.1Zm-2.981-12.608H79.443v9.911a.133.133,0,0,0,.118.142h7.688v1.464H79.585A1.6,1.6,0,0,1,78,182.355V170.512a1.6,1.6,0,0,1,1.583-1.612h.61v.735a1.464,1.464,0,1,0,2.928,0V168.9h6.745v.735a1.464,1.464,0,1,0,2.928,0V168.9h.6a1.6,1.6,0,0,1,1.588,1.612v5.708H93.524v-3.776Zm-2.193-2.081a.73.73,0,0,1-.735-.729v-2.928a.732.732,0,1,1,1.464,0v2.928a.728.728,0,0,1-.729.729Zm-9.673,0a.729.729,0,0,1-.729-.729v-2.928a.729.729,0,1,1,1.458,0v2.928a.728.728,0,0,1-.729.729ZM81.007,181v-1h1v1Zm0-6v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1ZM82.975,181v-1h1v1Zm0-6v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1ZM85.008,181v-1h1v1Zm0-6v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1Zm2,2.027v-1H88v1Zm0-6v-1H88v1Zm0,2v-1H88v1Zm0,1.968v-1H88v1Zm2-3.971v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1Zm2-3.971v-1h1v1Zm0,2v-1h1v1Z"
      transform="translate(-78.002 -165.971)"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/TradeControls/Icons.js